export default __webpack_public_path__ + "media/images/logo/logo-light-69200ec5a55c07dafce345167b7d630c.png";